export default __webpack_public_path__ + "static/media/wantai-mark.9aebdf50.png";